import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DataManagementService} from '../../services/data-management.service';
import {Student} from '../../model/student';
import {AppSettings} from '../../../app-settings';
import {Constants} from '../../constants';
import {AuthenticationService} from '../../services/authentication.service';
import {Subject} from 'rxjs';

@Component({
    selector: 'app-final-reports',
    templateUrl: './final-reports.component.html',
    styleUrls: ['./final-reports.component.css']
})
export class FinalReportsComponent implements OnInit {

    dtTrigger: Subject<string> = new Subject();
    dtOptions: DataTables.Settings = {};
    filter_id;
    title;
    token;
    students: Student[];
    outgoingTerm;
    finalAllottedUniversity;
    universityWiseFinalAllotment;
    optedOutStudents;
    outgoingTermId = '0';
    downloadFinalUniversityAllotmentExcel = AppSettings.DOWNLOAD_FINAL_UNIVERSITY_ALLOTMENT;
    downloadFinalUniversityWiseAllotmentExcel = AppSettings.DOWNLOAD_FINAL_UNIVERSITY_WISE_ALLOTMENT_DETAILS;
    downloadOptedOutStudentsExcel = AppSettings.DOWNLOAD_FINAL_OPTED_OUT_STUDENTS_REPORT;
    selectUndefinedOptionValue = '0';
    outgoingStudents = [];
    rowGroupMetadata: any;
    errorMessage;

    constructor(private route: ActivatedRoute,
                private dmService: DataManagementService,
                private authenticationService: AuthenticationService) {
    }

    getAllTerms() {
        this.dmService.getAll(Constants.TERM_SETTINGS)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.outgoingTerm = response.data.outgoing_terms;
                        if (this.outgoingTerm.length > 0) {
                            this.outgoingTermId = this.outgoingTerm[0].outgoing_term_id;
                        }
                        if (this.filter_id === 1) {
                            this.getFinalUniversityAllotment();
                        } else if (this.filter_id === 2) {
                            this.getFinalUniversityWiseAllotmentReport();
                        } else if (this.filter_id === 3) {
                            this.getOptedOutStudents();
                        }
                    } else if (response.status === 'fail') {
                        if (response.data.hasOwnProperty('message')) {
                            this.errorMessage = response.data.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    getFinalUniversityAllotment(): void {
        this.dmService.getOne(Constants.FINAL_UNIVERSITY_ALLOTMENT, this.outgoingTermId)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.finalAllottedUniversity = response.data;
                        if (this.finalAllottedUniversity.length === 0) {
                            this.errorMessage = 'There is no data available for Final Student Wise Allotment.';
                        } else {
                            this.dtTrigger.next();
                        }
                    } else if (response.status === 'fail') {
                        if (response.data.hasOwnProperty('message')) {
                            this.errorMessage = response.data.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    getFinalUniversityWiseAllotmentReport(): void {
        this.dmService.getOne(Constants.FINAL_UNIVERSITY_WISE_ALLOTMENT, this.outgoingTermId)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.universityWiseFinalAllotment = response.data;
                        if (this.universityWiseFinalAllotment.length === 0) {
                            this.errorMessage = 'There is no data available for Final University Wise Allotment';
                        } else {
                            this.updateRowGroupMetaData();
                        }
                    } else if (response.status === 'fail') {
                        if (response.data.hasOwnProperty('message')) {
                            this.errorMessage = response.data.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    getOptedOutStudents(): void {
        this.dmService.getOne(Constants.FINAL_OPTED_OUT_STUDENTS, this.outgoingTermId)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.optedOutStudents = response.data;
                        if (this.optedOutStudents.length === 0) {
                            this.errorMessage = 'There is no data available for Opted Out Students.';
                        } else {
                            this.dtTrigger.next();
                        }
                    } else if (response.status === 'fail') {
                        if (response.data.hasOwnProperty('message')) {
                            this.errorMessage = response.data.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    updateRowGroupMetaData() {
        this.rowGroupMetadata = {};
        if (this.universityWiseFinalAllotment) {
            for (let i = 0; i < this.universityWiseFinalAllotment.length; i++) {
                const rowData = this.universityWiseFinalAllotment[i];
                const universityNameWithSeats = rowData.university_name_with_seats;
                if (i === 0) {
                    this.rowGroupMetadata[universityNameWithSeats] = {index: 0, size: 1};
                } else {
                    const previousRowData = this.universityWiseFinalAllotment[i - 1];
                    const previousRowGroup = previousRowData.university_name_with_seats;
                    if (universityNameWithSeats === previousRowGroup) {
                        this.rowGroupMetadata[universityNameWithSeats].size++;
                    } else {
                        this.rowGroupMetadata[universityNameWithSeats] = {index: i, size: 1};
                    }
                }
            }
        }
    }

    termChange() {
        if (this.filter_id === 1) {
            this.getFinalUniversityAllotment();
        } else if (this.filter_id === 2) {
            this.getFinalUniversityWiseAllotmentReport();
        } else if (this.filter_id === 3) {
            this.getOptedOutStudents();
        }
    }

    ngOnInit() {
        this.token = '?token=' + this.authenticationService.getToken();
        this.route
            .params
            .subscribe(params => {
                this.filter_id = parseInt(params['id'], 10);
            });
        if (this.filter_id === 1) {
            this.title = 'Final Student-wise Allotment Report';
        } else if (this.filter_id === 2) {
            this.title = 'Final University-wise Allotment Report';
        } else if (this.filter_id === 3) {
            this.title = 'Opted Out Students Report';
        }
        this.getAllTerms();
        this.dtOptions = {
            paging: true,
            retrieve: true,
            destroy: true,
            lengthChange: true,
            info: false
        };
    }

}
